<template>
    <div>
        <!-- min-width: 520px;280px style="width:100%;height:100%;"-->
        <div style="box-size:border-box">
            <div id="main2" style="width:100%;height:240px"></div>
        </div>
  </div>
</template>

<script>
  
  import libs from '../../utils/libs'
  import store from "../../utils/storage";
  import echarts from 'echarts';
 
  import { getBaseUrl,GetWorkloadKpi } from "../../api/api";
  import { from } from 'linq';

  export default {
    data() {
      return {
        params:{
         TrainerId: 0,
          BeginDate: "",
          EndDate: "",
          College: "",
          Branch: "",
          TrainType: "",
          SearchKey: "",
          Type: 0
        },
        dataList:[],
        seriesList:[],
        DsTrainTypeList:[],
        DsRegionList:[],
        proportion2:[],
        hostUrl: getBaseUrl(),
        uploadHeaders: { 'Jwt-Token': store.getToken() },
        curUser: store.getUserInfo(),
        colors: [
            ["#1DE9B6", "#F46E36", "#04B9FF", "#5DBD32", "#FFC809", "#FB95D5", "#BDA29A", "#6E7074", "#546570", "#C4CCD3"],
            ["#16c8d6", "#67E0E3", "#32C5E9", "#9FE6B8", "#FFDB5C", "#FF9F7F", "#FB7293", "#E062AE", "#E690D1", "#E7BCF3", "#9D96F5", "#8378EA", "#8378EA"],
            ["#DD6B66", "#759AA0", "#E69D87", "#8DC1A9", "#EA7E53", "#EEDD78", "#73A373", "#73B9BC", "#7289AB", "#91CA8C", "#F49F42", "#8378EA", "#8378EA"],
        ],
      };
    },
    watch:{
     
    },
    mounted() {
      
      setTimeout(()=>{
        this.initChart();
        this.search();
      },10)
     
    },
    methods: {
      search() {
      this.chartLoading = true;
      // GetTrainKpi(this.params).then();
        GetWorkloadKpi(this.params).then((res) => {
        if (res.data.Code != 1) return;
        this.dataList = res.data.Data;
        this.seriesList=[];
        this.DsTrainTypeList =[];
        this.DsRegionList =[];
        this.proportion2=[];
        this.dataList.forEach(e=>{
          if(this.DsTrainTypeList.indexOf(e.TrainType)<0)
          {
              this.DsTrainTypeList.push(e.TrainType);
          }
          if(this.DsRegionList.indexOf(e.Region)<0)
          {
              this.DsRegionList.push(e.Region);
          }
          //this.seriesList.push({name:e.TrainType,type: "bar",data:[e.Value],label:{show:true}}) 
        })
        this.DsTrainTypeList.forEach(e=>{
          
            var arrDt=new Array(this.DsRegionList.length);
            var iCounts=0;
            this.dataList.forEach(k=>{
              if(k.TrainType==e)
              {
                arrDt[this.DsRegionList.indexOf(k.Region)]=k.Value;
                iCounts+=k.Value;
              }
            })
            this.seriesList.push({name:e,type: "bar",data:arrDt,label:{show:true}})
            // this.proportion2.push({value: iCounts, name: e });
        } 
        )
        setTimeout(() => {
          this.initChart();
          // this.myChart2();
          this.chartLoading = false;
        }, 100);
      });
      console.log('11111',this.DsRegionList);
    },

      initChart(){
        // 基于准备好的dom，初始化echarts实例
        var myChart = echarts.init(document.getElementById('main2'));
        var option = {
          backgroundColor: "transparent",//#344b58
          color:this.colors[1],
          title: {
            text: "日报",
            left: 'center',
            // top:10,
            bottom:20,
            textStyle: {
              color: '#000',
              fontSize: '16'
            },
          },
          tooltip: {
            trigger: 'axis',
            axisPointer: {
              type: 'cross',
              crossStyle: {
                color: '#999'
              }
            }
          },
          grid: {
            borderWidth: 0,
            top: "12%",
            left:'3%',
            height:'68%',
            width: "90%",
            textStyle: {
              color: "#fff"
            },
            containLabel: true,
          },
          calculable: true,
          xAxis: [{
            type: 'category',
            //  data: ['协防辅导','日常办公','出差在途','测评补考','业务会议','大学会议','TTT','课程认证','课程演练','工作坊','课程培训','业务项目','工作调休','法定休假'],
             data:this.DsRegionList,
             
            axisPointer: {
              type: 'shadow'
            },
            axisLabel: {
              interval:0, //坐标刻度之间的显示间隔，默认就可以了（默认是不重叠）
              rotate:30   //调整数值改变倾斜的幅度（范围-90到90）
            }
          }],
          yAxis: [{
            type: 'value',
            name: '入组数',
            min: 0,
            axisLabel: {
            formatter: '{value}'
            }
          }],
          series:this.seriesList,
          // series: [{
          //   name: '工作量',
          //   type: 'bar',
          //   data: [120, 150, 140, 148,192,122,139,94,103,144,129,100,23,20],
          //   // barWidth:30,
          //   label: {
          //     show: true
          //   },
          // }]

        }
        myChart.setOption(option);
      },
   
    }
  };
</script>

<style lang="less" scoped>
  @import "../../assets/css/list.css";
  .item1{
    display: block;
  }
  
  .item2{
    display: block;
    margin-top: 10px;
  }
  /deep/ .el-input--mini .el-input__inner{
    height: 28px!important;
  }
  /deep/ .el-cascader__tags{
    flex-wrap: inherit;
  }
//   /deep/ .el-form--inline .el-form-item{
//       display: block;
//   }

</style>


// WEBPACK FOOTER //
// src/components/public/HomeEcharts2.vue